@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package com.artvending.warden

import kotlinx.coroutines.await
import org.w3c.dom.events.Event
import org.w3c.dom.events.EventTarget
import kotlin.js.*
import kotlin.js.Promise

external class IDBDatabase : EventTarget {
	fun createObjectStore(name: String, options: dynamic = definedExternally): IDBObjectStore
	fun transaction(storeName: String, mode: String = definedExternally): IDBTransaction
}

external class IDBTransaction : EventTarget {
	val mode: String
	fun objectStore(name: String): IDBObjectStore
}

external class IDBObjectStore : EventTarget {
	fun add(value: Any?, key: Any? = definedExternally): IDBRequest<*>
	fun put(value: Any?, key: Any? = definedExternally): IDBRequest<*>
	fun get(key: Any?): IDBRequest<*>
}

open external class IDBRequest<T> : EventTarget {
	var onsuccess: ((Event) -> Unit)?
	var onerror: ((Event) -> Unit)?
	val result: T
}

external class IDBOpenDBRequest : IDBRequest<IDBDatabase> {
	var onupgradeneeded: ((Event) -> Unit)?
}


class JsDb: Db {
	override suspend fun getParameter(key: String, defaultValue: String): String {
		val db = openDatabase(DATABASE_NAME, DATABASE_VERSION).await()
		
		return getParameter(db, key).await() ?: defaultValue
	}
	
	override suspend fun setParameter(key: String, value: String) {
		val db = openDatabase(DATABASE_NAME, DATABASE_VERSION).await()
		saveParameter(db, key, value).await()
	}
	
	
	private fun openDatabase(name: String, version: Int): Promise<IDBDatabase> {
		return Promise { resolve, reject ->
			val request: IDBOpenDBRequest = js("window.indexedDB.open(name, version)")
			request.onsuccess = { resolve(request.result as IDBDatabase) }
			request.onerror = { reject(Throwable("Error opening database")) }
			request.onupgradeneeded = { event ->
				val db = (event.target as IDBOpenDBRequest).result as IDBDatabase
				db.createObjectStore(STORE_NAME)
			}
		}
	}
	
	private fun saveParameter(db: IDBDatabase, key: String, value: String): Promise<Unit> {
		return Promise { resolve, reject ->
			val transaction = db.transaction(STORE_NAME, "readwrite")
			val store = transaction.objectStore(STORE_NAME)
			val request = store.put(value, key)
			request.onsuccess = { resolve(Unit) }
			request.onerror = { reject(Throwable("Error saving parameter")) }
		}
	}
	
	private fun getParameter(db: IDBDatabase, key: String): Promise<String?> {
		return Promise { resolve, reject ->
			val transaction = db.transaction(STORE_NAME, "readonly")
			val store = transaction.objectStore(STORE_NAME)
			val request = store.get(key)
			request.onsuccess = { resolve(request.result as? String) }
			request.onerror = { reject(Throwable("Error getting parameter")) }
		}
	}
	
	
	companion object {
		private const val DATABASE_NAME = "pikalka_database"
		private const val STORE_NAME = "pikalka_store"
		private const val DATABASE_VERSION = 1
	}
}